// helpers/rutaChoferes.js
import axios from "axios";

// Base tomada del .env o fallback a producción
const RAW_BASE_URL = import.meta.env?.VITE_API_URL || "https://backsanpancracio.us-3.evennode.com";
const BASE_URL = RAW_BASE_URL.replace(/\/+$/, "");     // quita / al final
const API = axios.create({ baseURL: BASE_URL });

// arma paths sin slash inicial
const p = (s) => String(s || "").replace(/^\/+/, "");

// header con token si existe
const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

// ---- CHOFERES ----

// GET: lista
export const getChoferes = async () => {
  const { data } = await API.get(p("choferes"), auth());
  // normalmente el back responde { ok, choferes, cantidad }
  return data;
};

// GET: uno por id
export const getChoferById = async (id) => {
  const { data } = await API.get(p(`choferes/${id}`), auth());
  return data;
};

// POST: crear
export const postChofer = async (payload) => {
  const { data } = await API.post(p("choferes"), payload, auth());
  return data;
};

// PUT: actualizar
export const putChofer = async (id, payload) => {
  const { data } = await API.put(p(`choferes/${id}`), payload, auth());
  return data;
};

// DELETE: baja lógica
export const deleteChofer = async (id) => {
  const { data } = await API.delete(p(`choferes/${id}`), auth());
  return data;
};
